// Fourchettes indicatives de prime annuelle RC Pro + décennale communiquées par le
// cabinet (document « Tarif décennale »). Source unique pour l'accueil, la page Prix,
// les fiches métiers et le formulaire de devis.
export const TARIFS_YEAR = 2026;

export const TARIFS = {
  vrd: [4000, 6000],
  macon: [3000, 5000],
  "charpentier-bois": [2600, 5000],
  "charpentier-metallique": [3200, 5000],
  terrassier: [3500, 6000],
  couvreur: [2400, 5000],
  facadier: [3500, 6000],
  "menuisier-interieur": [1300, 3000],
  "menuisier-exterieur": [1300, 3000],
  "chauffagiste-climaticien": [2400, 4000],
  plombier: [2000, 3600],
  fumiste: [5200, 7000],
  electricien: [1200, 2500],
  carreleur: [2300, 4000],
  serrurier: [1300, 3000],
  peintre: [1000, 2500],
  vitrier: [1000, 2500],
  "revetements-souples": [1300, 3000],
  "platrier-plaquiste": [1400, 3000],
  isolation: [2300, 4000],
  "isolation-exterieure": [3500, 6000],
  agenceur: [1300, 2000],
};

// Formatage manuel (et non Intl) : résultat identique au pré-rendu et dans tous les
// navigateurs, espaces insécables pour éviter « 3 » / « 000 € » sur deux lignes.
const NBSP = "\u00a0";
const eur = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);

export const monthly = (n) => Math.round(n / 12);

// « 3 000 – 5 000 € »
export const formatRange = ([min, max]) => `${eur(min)} – ${eur(max)}${NBSP}€`;

// « 250 – 417 € »
export const formatMonthlyRange = ([min, max]) => `${eur(monthly(min))} – ${eur(monthly(max))}${NBSP}€`;

// « 3 000–5 000 € » (titres courts)
export const formatRangeCompact = ([min, max]) => `${eur(min)}–${eur(max)}${NBSP}€`;

export const tarifFor = (slug) => TARIFS[slug] || null;
